import "./bootstrap.js";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/v24/institution-native-v20.css";
import "./styles/v24/access-v6.css";
import "./styles/v24/institutions-v1.css";
import "./styles/v24/institution-portal-v1.css";
import "./styles/v24/toolbar-spacing-v9.css";
import "./styles/v24/task-cards-v12.css";
import "./styles/v24/profile-avatars-v16.css";
import "./styles/v24/institution-management-v19.css";
import "./styles/v24/school-flow-v19.css";
import "./styles/v24/school-records-v21.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
